import { gql } from "@apollo/client";

export const GET_FILELIST_RESULTS = (
  limit: any,
  skip = 0,
  tags?: string[],
  filter?: string,
  preview?: boolean,
) => `
query FileListResultType {
  fileBlockCollection(preview: ${
    preview ?? false
  }, limit: ${limit}, order: name_ASC, skip: ${skip} ${
    tags?.length
      ? `, where: {
      contentfulMetadata: {
        tags_exists: true
        tags: {
          ${filter}: [${tags.map((item) => {
            return `"${item}"`;
          })}]
        }
    }
    })`
      : `)`
  }
  {
	  total
  	items {
    	sys {
        publishedAt
        firstPublishedAt
        id
        __typename
      }
        name
        imageVaultFile
        ivThumbnail
        metaData
        relatedInfoLink {
          linkText
          globalLinkItem
          reference {
            ...on Page {
              content {
                __typename
              }
              slug
            }
            ...on FileBlock
            {
              imageVaultFile
            }
          }
          url
          newTab
          ikon
        }
        __typename
      }
    }
}`;

export const GET_FILELIST_QUERY_RESULT = gql`
  query FileListResultType {
    fileBlockCollection {
      total
      items {
        sys {
          publishedAt
          firstPublishedAt
          id
          __typename
        }
        name
        imageVaultFile
        metaData
        ivThumbnail
        relatedInfoLink {
          linkText
          globalLinkItem
          reference {
            ... on Page {
              content {
                __typename
              }
              slug
            }
            ... on FileBlock {
              imageVaultFile
            }
          }
          url
          newTab
          ikon
        }
        __typename
      }
    }
  }
`;
